import React from 'react';
import { Logo } from '../../../features/api/apiSlice';

interface LogoRendererProps {
  logo: Logo;
  imageClassName?: string;
}

export const LogoRenderer: React.FC<LogoRendererProps> = ({
  logo,
  imageClassName
}) => {
  if (!logo.url) {
    return <div className={imageClassName} />;
  }

  return (
    <img
      src={logo.url}
      alt="Логотип"
      className={imageClassName}
    />
  );
};